import { Box, BoxProps, alpha, styled } from '@mui/material';

/**
 * Standard styled box container with light primary fill.
 * @returns {JSX.Element}
 */
const FilledContainer = styled(Box)<BoxProps>(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.light, 0.8),
  borderRadius: 24,
  padding: '2% 3%'
}));

export default FilledContainer;
